import ReactJson from "react-json-view";
import useDarkMode from "use-dark-mode";
import { Card, CardContent } from "@/components/ui/card";

interface VisualiseJsonProps {
  object: object;
}

export const VisualiseJson = (props: VisualiseJsonProps) => {
  const { value: isDark } = useDarkMode(false, { classNameDark: "dark" });

  return (
    <Card>
      <CardContent className="py-4">
        <div className="overflow-auto h-58">
          <ReactJson
            name={false}
            src={props.object}
            displayDataTypes={false}
            displayObjectSize={false}
            theme={isDark ? "bright" : "rjv-default"}
            enableClipboard={true}
          />
        </div>
      </CardContent>
    </Card>
  );
};
